import { HCD_HIRING } from '../../data/federation';

export default function HiringChart() {
  // Simple growth bars for hires across the group
  const W = 280;
  const H = 130;
  const padL = 12;
  const padR = 12;
  const padT = 16;
  const padB = 26;
  const iw = W - padL - padR;
  const ih = H - padT - padB;
  const max = 450;
  const data = HCD_HIRING;
  const bw = iw / (data.length * 2);
  const yAt = (v: number) => padT + ih - (v / max) * ih;

  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: 'auto' }}>
      <line x1={padL} x2={padL + iw} y1={padT + ih} y2={padT + ih} stroke="#0F0F0F" />
      {data.map((d, i) => {
        const x = padL + (i * 2 + 1) * bw - bw * 0.6;
        const w = bw * 1.2;
        const y = yAt(d.n);
        return (
          <g key={i}>
            <rect
              x={x}
              y={y}
              width={w}
              height={padT + ih - y}
              fill={i === data.length - 1 ? '#E61919' : '#F09595'}
            />
            <text
              x={x + w / 2}
              y={y - 4}
              textAnchor="middle"
              fontFamily="Inter Tight, sans-serif"
              fontWeight="600"
              fontSize="11"
              fill="#0F0F0F"
            >
              ~{d.n}
            </text>
            <text
              x={x + w / 2}
              y={padT + ih + 14}
              textAnchor="middle"
              fontFamily="JetBrains Mono, monospace"
              fontSize="10"
              fill="#5B5C57"
            >
              {d.y}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
